import React, { FC } from 'react'

import {
  RangeValuesFilter,
  RangeValuesProps,
} from '@new/__global/components/Filters/FiltersVariations/Range'
import { filtersLabels } from '@new/domains/bookings/screens/bookingsList/utils/labels'

import { FiltersSharedProps } from './Filters.types'

interface Range {
  from?: string
  to?: string
}

interface BedroomsRangeFilterProps extends FiltersSharedProps {
  initialValue?: Range
  onChange: (value?: Range) => void
}

export const BedroomsRangeFilter: FC<BedroomsRangeFilterProps> = ({
  initialValue,
  onChange,
  ...props
}) => {
  const handleBedroomsRangeChange = ({ fromRangeValue, toRangeValue }: RangeValuesProps) => {
    onChange({ from: fromRangeValue, to: toRangeValue })
  }

  return (
    <RangeValuesFilter
      title={filtersLabels.bedroomsRange}
      fromInputTypeIndicator="Min"
      toInputTypeIndicator="Max"
      shouldDisplayFiltersOnSameLine
      onChange={handleBedroomsRangeChange}
      rangeValues={{
        fromRangeValue: initialValue?.from,
        toRangeValue: initialValue?.to,
      }}
      placeholder={{ from: '0', to: '1' }}
      {...props}
    />
  )
}
